import { render, staticRenderFns } from "./Page7.vue?vue&type=template&id=6b9838d4&"
import script from "./Page7.vue?vue&type=script&lang=js&"
export * from "./Page7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports